import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Col, Row } from 'antd'
import { Formik } from 'formik'
import * as Yup from 'yup'

import updateWaitingPeriod, {
  WaitingPeriodValues,
} from 'core/application/adminDashboard/benefitDetails/design/waitingPeriod'

import Radio from 'common/components/dataEntry/formik/FormikRadioField'
import Alert from 'common/components/feedback/Alert'
import notification from 'common/components/feedback/Notification'

import { commandRequest } from 'common/RequestUtils'

import { BaseComponentProps } from '../../../../common/productClassWizardModal/Common'

const formValidator = (translate: any) =>
  Yup.object({
    waitingPeriod: Yup.number()
      .required(translate('general.required'))
      .oneOf([0, 30, 60, 90])
      .typeError(translate('admin-dashboard.benefit-details.class-design.errors.enter-number')),
  })

const WaitingPeriod: React.FC<BaseComponentProps<WaitingPeriodValues>> = (props) => {
  const { bindSubmitFormHandler } = props
  const { t: translate } = useTranslation()
  const { planPeriod } = useParams<any>()

  useEffect(() => {
    props.setIsFormValid(formValidator(translate).isValidSync(props.state))
  }, [])

  const onSubmit = async (values: WaitingPeriodValues) => {
    var request = { ...values, planPeriodId: planPeriod }
    let result = await commandRequest(() => updateWaitingPeriod(request))

    if (!result.errors) {
      props.goNext()
    } else {
      props.setIsSubmiting(false)
      notification.open({
        message: result.errors[0],
        type: 'error',
      })
    }
  }

  return (
    <Formik
      enableReinitialize={true}
      validationSchema={formValidator(translate)}
      initialValues={props.state}
      onSubmit={onSubmit}
      validate={(values) => {
        const isValid: boolean = formValidator(translate).isValidSync(values)
        props.setHasDirtyData(isValid)
        props.setIsFormValid(isValid)
        return {}
      }}
    >
      {(formik) => {
        const { handleSubmit, submitForm } = formik
        bindSubmitFormHandler(submitForm)
        return (
          <form autoComplete="off" onSubmit={handleSubmit} className="waiting_period">
            <Row>
              <Col span={22}>
                <h5 className="waiting_period_info pl-8">
                  {translate('admin-dashboard.benefit-details.class-design.waiting-period.header')}
                </h5>
              </Col>
            </Row>

            <Row className="pt-16">
              <Col span={22} className="pl-8 pr-8">
                <Alert
                  showIcon
                  type="info"
                  message={translate('admin-dashboard.benefit-details.class-design.waiting-period.alert-header')}
                  description={translate('admin-dashboard.benefit-details.class-design.waiting-period.alert-desc')}
                ></Alert>
              </Col>
            </Row>
            <Row gutter={10} className="pt-16">
              <Col span={24}>
                <Radio.Group name="waitingPeriod" className="w-100" defaultValue={props.state.waitingPeriod}>
                  <Row gutter={10} className="mb-8">
                    <Col span={12}>
                      <Radio.Button value={0}>
                        {translate('admin-dashboard.benefit-details.class-design.waiting-period.no-waiting')}
                      </Radio.Button>
                    </Col>
                    <Col span={12}>
                      <Radio.Button value={30}>
                        {translate('admin-dashboard.benefit-details.class-design.waiting-period.30-waiting')}
                      </Radio.Button>
                    </Col>
                  </Row>
                  <br />
                  <Row gutter={10}>
                    <Col span={12}>
                      <Radio.Button value={60}>
                        {translate('admin-dashboard.benefit-details.class-design.waiting-period.60-waiting')}
                      </Radio.Button>
                    </Col>
                    <Col span={12}>
                      <Radio.Button value={90}>
                        {translate('admin-dashboard.benefit-details.class-design.waiting-period.90-waiting')}
                      </Radio.Button>
                    </Col>
                  </Row>
                </Radio.Group>
              </Col>
            </Row>
          </form>
        )
      }}
    </Formik>
  )
}

export default WaitingPeriod
